import { Fragment } from "react";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";

import { Row, Col } from "reactstrap";

import { Sparklines, SparklinesCurve } from "react-sparklines";

import CountUp from "react-countup";

function boxMullerRandom() {
  let phase = true,
    x1,
    x2,
    w;

  return (function () {
    if (phase) {
      do {
        x1 = 2.0 * Math.random() - 1.0;
        x2 = 2.0 * Math.random() - 1.0;
        w = x1 * x1 + x2 * x2;
      } while (w >= 1.0);

      w = Math.sqrt((-2.0 * Math.log(w)) / w);
      return x1 * w;
    } else {
      return x2 * w;
    }
  })();
}

function randomData(n = 30) {
  return Array.apply(0, Array(n)).map(boxMullerRandom);
}

const sampleData = randomData(10);
const sampleData2 = randomData(15);
const sampleData3 = randomData(8);
const sampleData4 = randomData(12);

const GraphCards = ({
  obj,
  changeColor = false,
  changeMapCategory = false,
  setAnimation = false,
  setIsInterval,
}) => {
  function setSocialMapPieChart(color, category) {
    if (changeColor) {
      setIsInterval(false);
      changeColor(color);
      changeMapCategory(category);
      setAnimation(true);
      setTimeout(() => setAnimation(false), 1000);
    }
  }

  return (
    <Fragment>
      <CSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear={true}
        transitionAppearTimeout={0}
        transitionEnter={false}
        transitionLeave={false}
      >
        <div>
          <Row>
            <Col lg="12" xl="12">
              <Row>
                <Col
                  md="6"
                  lg="3"
                  xl="3"
                  style={{ cursor: "pointer" }}
                  className="hover-dark"
                >
                  <div
                    onClick={() => {
                      setSocialMapPieChart("#3ac47d", "businesses");
                    }}
                    className="card mb-3 widget-chart widget-chart2 text-left card-btm-border card-shadow-success border-success"
                  >
                    <div className="widget-chat-wrapper-outer fiscalNameCard">
                      <div className="hatena">
                        ？{" "}
                        <p className="explaine">
                          全Social map掲載組織が実施する事業の合計数
                        </p>
                      </div>
                      <div
                        className="widget-chart-content pl-1 pr-1 pb-1"
                        style={{ marginTop: 10 }}
                      >
                        <h6 className="widget-heading mb-0">事業数</h6>
                        <div className="widget-chart-flex">
                          <div className="widget-numbers">
                            <div className="widget-chart-flex">
                              <div
                                className="fsize-3"
                                style={{ marginTop: -10, fontWeight: "bold" }}
                              >
                                <CountUp
                                  start={0}
                                  end={obj.businesses}
                                  separator=","
                                  decimals={0}
                                  decimal=""
                                  prefix=""
                                  duration="1"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <h6 className="widget-subheading mb-0 opacity-5">
                          (総事業数{" "}
                          {obj.total_businesses &&
                            obj.total_businesses.toLocaleString()}
                          )
                        </h6>
                      </div>
                      {/* <Row className="no-gutters widget-chart-wrapper mt-3 mb-3 pl-2 he-auto">
                        <Col md="9">
                          <Sparklines>
                            折れ線
                            <Sparklines data={sampleData}>
                            <SparklinesCurve
                              style={{
                                strokeWidth: 3,
                                stroke: "var(--success)",
                                fill: "none",
                              }}
                            />
                          </Sparklines>
                        </Col>
                      </Row> */}
                    </div>
                  </div>
                </Col>
                <Col
                  md="6"
                  lg="3"
                  xl="3"
                  style={{ cursor: "pointer" }}
                  className="hover-dark"
                >
                  <div
                    onClick={() => {
                      setSocialMapPieChart("#555cd8", "business_cost");
                    }}
                    className="card mb-3 widget-chart widget-chart2 text-left card-btm-border card-shadow-primary border-primary"
                  >
                    <div className="widget-chat-wrapper-outer fiscalNameCard">
                      <div className="hatena">
                        ？{" "}
                        <p className="explaine">
                          全Social map掲載組織が実施する事業の支出の合計額
                        </p>
                      </div>
                      <div
                        className="widget-chart-content pl-1 pr-1 pb-1 "
                        style={{ marginTop: 10 }}
                      >
                        <h6 className="widget-heading mb-0">事業額</h6>
                        <div className="widget-chart-flex">
                          <div className="widget-numbers">
                            <div className="widget-chart-flex">
                              <div
                                className="fsize-3"
                                style={{
                                  marginTop: -10,
                                  fontWeight: "bold",
                                }}
                              >
                                <CountUp
                                  start={0}
                                  end={obj.business_cost}
                                  separator=","
                                  decimals={0}
                                  decimal=""
                                  prefix=""
                                  duration="1"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <h6 className="widget-subheading mb-0 opacity-5">
                          (総額
                          {obj.total_business_cost &&
                            obj.total_business_cost.toLocaleString()}
                          円)
                        </h6>
                      </div>
                      {/* <Row className="no-gutters widget-chart-wrapper mt-3 mb-3 pl-2 he-auto">
                        <Col md="9">
                          <Sparklines>
                            <SparklinesCurve
                              style={{
                                strokeWidth: 3,
                                stroke: "var(--primary)",
                                fill: "none",
                              }}
                            />
                          </Sparklines>
                        </Col>
                      </Row> */}
                    </div>
                  </div>
                </Col>
                <Col
                  md="6"
                  lg="3"
                  xl="3"
                  style={{ cursor: "pointer" }}
                  className="hover-dark"
                >
                  <div
                    onClick={() => {
                      setSocialMapPieChart("#f8b823", "workers");
                    }}
                    className="card mb-1 widget-chart widget-chart2 text-left card-btm-border card-shadow-warning border-warning"
                  >
                    <div className="widget-chat-wrapper-outer fiscalNameCard">
                      <div className="hatena">
                        ？{" "}
                        <p className="explaine">
                          全Social map掲載組織が実施する事業に従事する人数の合計
                        </p>
                      </div>
                      <div
                        className="widget-chart-content pl-1 pr-1 pb-1"
                        style={{ marginTop: 10 }}
                      >
                        <h6 className="widget-heading mb-0">事業の従事者数</h6>
                        <div className="widget-chart-flex">
                          <div className="widget-numbers">
                            <div className="widget-chart-flex">
                              <div
                                className="fsize-3"
                                style={{ marginTop: -10, fontWeight: "bold" }}
                              >
                                <CountUp
                                  start={0}
                                  end={obj.workers}
                                  separator=","
                                  decimals={0}
                                  decimal=""
                                  prefix=""
                                  duration="1"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <h6 className="widget-subheading mb-0 opacity-5">
                          (総人数{" "}
                          {obj.total_workers &&
                            obj.total_workers.toLocaleString()}
                          人)
                        </h6>
                      </div>
                      {/* <Row className="no-gutters widget-chart-wrapper mt-3 mb-3 pl-2 he-auto">
                        <Col md="9">
                          <Sparklines>
                            <SparklinesCurve
                              style={{
                                strokeWidth: 3,
                                stroke: "var(--warning)",
                                fill: "none",
                              }}
                            />
                          </Sparklines>
                        </Col>
                      </Row> */}
                    </div>
                  </div>
                </Col>
                <Col
                  md="6"
                  lg="3"
                  xl="3"
                  style={{ cursor: "pointer" }}
                  className="hover-dark"
                >
                  <div
                    onClick={() => {
                      setSocialMapPieChart("#d92550", "beneficiaries");
                    }}
                    className="card mb-3 widget-chart widget-chart2 text-left card-btm-border card-shadow-danger border-danger"
                  >
                    <div className="widget-chat-wrapper-outer fiscalNameCard">
                      <div className="hatena">
                        ？{" "}
                        <p className="explaine">
                          全Social
                          map掲載組織が実施する事業を通じて利益・支援を得た人（受益者）の人数の合計
                        </p>
                      </div>
                      <div
                        className="widget-chart-content pl-1 pr-1 pb-1"
                        style={{ marginTop: 10 }}
                      >
                        <h6 className="widget-heading mb-0">事業の受益者数</h6>
                        <div className="widget-chart-flex">
                          <div className="widget-numbers">
                            <div className="widget-chart-flex">
                              <div
                                className="fsize-3"
                                style={{ marginTop: -10, fontWeight: "bold" }}
                              >
                                <CountUp
                                  start={0}
                                  end={obj.beneficiaries}
                                  separator=","
                                  decimals={0}
                                  decimal=""
                                  prefix=""
                                  duration="1"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <h6 className="widget-subheading mb-0 opacity-5">
                          (総人数{" "}
                          {obj.total_beneficiaries &&
                            obj.total_beneficiaries.toLocaleString()}
                          人)
                        </h6>
                      </div>
                      {/* <Row className="no-gutters widget-chart-wrapper mt-3 mb-3 pl-2 he-auto">
                        <Col md="9">
                          <Sparklines>
                            <SparklinesCurve
                              style={{
                                strokeWidth: 3,
                                stroke: "var(--danger)",
                                fill: "none",
                              }}
                            />
                          </Sparklines>
                        </Col>
                      </Row> */}
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </CSSTransitionGroup>
    </Fragment>
  );
};

export default GraphCards;
